import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCategoryState: IBenefitMasterData = {
  data: {
    benefitMaster: [],
    meta: {},
  },
  deleteSuccess: false,
  sortBenefitMasterData: [],

  loading: false,
  success: false,
}

export interface IBenefitMasterData {
  data: {
    benefitMaster: any
    meta: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  sortBenefitMasterData: IBenefitMasterData[]
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IBenefitMasterData = initialCategoryState,
  action: ActionWithPayload<IBenefitMasterData>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_BENEFIT_MASTER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_ALL_BENEFIT_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_SPECIFIC_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_SPECIFIC_BENEFIT_MASTER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_SPECIFIC_BENEFIT_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_BENEFIT_MASTER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_BENEFIT_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_BENEFIT_MASTER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_BENEFIT_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_BENEFIT_MASTER_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_BENEFIT_MASTER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_BENEFIT_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_BENEFIT_MASTER_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_BENEFIT_MASTER_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_BENEFIT_MASTER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_BENEFIT_MASTER_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_BENEFIT_MASTER_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_BENEFIT_MASTER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_BENEFIT_MASTER_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_BENEFIT_MASTER_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_BENEFIT_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_BENEFIT_MASTER_SUCCESS: {
      return {
        ...state,
        sortBenefitMasterData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_BENEFIT_MASTER_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_BENEFIT_MASTER_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortBenefitMasterData: [],
      }
    }

    default:
      return state
  }
}
